// Feature flags. Flip AI back on with REACT_APP_AI_ENABLED=true in frontend/.env
// (and AI_FEATURES=on in backend/.env), then restart the services.
export const AI_ENABLED = process.env.REACT_APP_AI_ENABLED === "true";
